<!DOCTYPE html><div class="container">
  <div class="row top-padding">
    <!-- <div> -->
      <img id="hiLogo" src="assets/images/hi_logo_long.png" style="max-width: 100%;height: auto;" />
    <!-- </div> -->
    <!-- <h3 class="head">
      Health Institute <br />
    </h3> -->
  </div>
<hr />
<div style="text-align: left;">
  <p id="back-link">
    <a routerLink="../">返回</a>
  </p>
</div>

<hr />

<div class=containerframe>

  <iframe class="rframe" width="100%" height="auto" src="https://www.youtube.com/embed/NmLxYY0XPQ0">
  </iframe>
</div>

<br />

<img width="100%" src="../../assets/images/hiappleafletpc.png">



</div>
